import {
	Component,
	ChangeDetectorRef,
	HostBinding,
	ElementRef,
	Injector,
	AfterContentInit,
	Renderer2,
	EventEmitter,
} from '@angular/core';
import { get } from 'lodash';
import { ActionApiService } from '../Services/action-api/action-api.service';
import { Layoutresolver } from '../Services/layout/layout-resolver';
import { StoreService } from '../Services/store';
import { ObservablesService } from '../Services/observables/observables';
import { LayoutService } from '../Services/layout/layout.service';
import { SplunkAnalyticsService } from '../Services/splunk-analytics/splunk-analytics-service';
import { CarrierInformationService } from '../Services/carrier-information-service/carrier-information-service';

@Component({ template: '' })
export class BaseComponent implements AfterContentInit {
	control: control;
	ajaxAction: any;
	error: any;
	componentClass: any;
	value: any;
	setAnswer: any;
	auditing: any;
	isMobile: boolean;
	context: any;
	class: any;
	setInitialAnswer: any;
	actionService: ActionApiService;
	layoutService: LayoutService;
	layoutresolver: Layoutresolver;
	storeService: StoreService;
	observablesService: ObservablesService;
	splunkAnalyticsService: SplunkAnalyticsService;
	carrierInformationService: CarrierInformationService;
	subscriptions: any[];
	Renderer: Renderer2;
	cdRef: ChangeDetectorRef;
	elementRef: ElementRef;
	self: any;
	@HostBinding('attr.name')
	layout = this.control ? this.control.name : '';
	myCustomClass: string;
	valueChangeEventEmitter: EventEmitter<void> = new EventEmitter<void>();

	constructor(injector: Injector) {
		this.subscriptions = [];
		// this.eventService = injector.get(EventService);
		this.elementRef = injector.get(ElementRef);
		this.actionService = injector.get(ActionApiService);
		this.layoutService = injector.get(LayoutService);
		this.layoutresolver = injector.get(Layoutresolver);
		this.storeService = injector.get(StoreService);
		this.splunkAnalyticsService = injector.get(SplunkAnalyticsService);
		this.observablesService = injector.get(ObservablesService);
		this.carrierInformationService = injector.get(CarrierInformationService);
		this.cdRef = injector.get(ChangeDetectorRef);
		this.Renderer = injector.get(Renderer2);
		this.self = this;

		this.observablesService.UpdateBinding.subscribe((controls: control[]) => {
			if (this.self.control && this.self.control.name) {
				this.updateData();
			}
		});
	}

	updateData() {
		if (this.self.control) {
			this.error = this.storeService.getError(this.self.control, this.self.context);
			this.value = this.storeService.getValue(this.self.control.name, this.self.context);
			this.auditing = this.storeService.getAuditing(this.self.control, this.self.context);
			this.control = this.storeService.getControl(
				this.self.control.name,
				this.self.control.controlType,
				this.self.context
			);
			this.valueChangeEventEmitter.emit();
		}
	}

	ngAfterContentInit() {
		if (this.control) {
			this.myCustomClass = this.setClass();
		}

		if (this.self.control && this.self.control.name && this.self.control.name.indexOf('Address') > -1) {
			this.observablesService.addressChanged.subscribe((res) => {
				this.updateData();
			});
		}
	}

	setClass() {
		return `${get(this.self.control, 'attributes.class')} col-${this.control.width}`;
	}
}
